/// <amd-module name="typeahead/features/IncludeHotelsNearRegion" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

/// <reference path="../../typings/typeahead/loc.d.ts" />

"use strict";

import {ClientHandlerRegistry, IHsrpSubmitData} from "typeahead/client/ClientHandlerRegistry";
import {IInputElementConfig} from "typeahead/core/ExpediaSuggestServiceRequestGenerator";
import {ElementFocusedMessage} from "typeahead/core/message/ElementFocusedMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IExtraSearchParam} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {Optional} from "typeahead/core/util/Optional";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] =
    [
        {
            clients: ["Hotels.Search"],
        },
    ];

const featureFlag = "onesearchta";
const hotelNameHotelBits = 128; // (hotelNameHotelBits >>> 0).toString(2) = "10000000"

export class IncludeHotelsNearRegion implements IRequestUrlParamModifier, IPageLoadHandler {

    private static readonly applicableClientIds: string[] = ["Hotels.Search"];
    private static readonly applicableTextInputElementIds: string[] = ["inpSearchNear"];

    private static updateQueryParam(urlQueryString: string, key: string, value: string): string {
        const newParam: string = key + "=" + value;
        let params: string = "?" + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {

            const updateRegex: RegExp = new RegExp(key + "[^&]*");
            const removeRegex: RegExp = new RegExp(key + "=[^&;]+[&;]?");

            if (typeof value === "undefined" || value === null || value === "") {
                // Remove param if value is empty
                params = urlQueryString
                    .replace(removeRegex, "$1")
                    .replace(/[&;]$/, "");
            } else if (urlQueryString.match(updateRegex) !== null) {
                // If param exists already, update it
                params = urlQueryString.replace(updateRegex, "" + newParam);
            } else {
                // Otherwise, add it to end of query string
                params = urlQueryString + "&" + newParam;
            }
        }
        return params;
    }

    private latLong: string;
    private regionId: string;
    private selected: string;
    private searchPriorityOverride: string;
    private cityName: string;

    // Check for input element ID as well (Only for change search)
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IInputElementConfig):
        ISuggestServiceQueryParams {
        /* Verify that the experiment is only for HSRP and for Change search input TA*/
        if (IncludeHotelsNearRegion.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
            && IncludeHotelsNearRegion.applicableTextInputElementIds.indexOf(options.inputElementId) > -1) {
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                params.rid = options.searchRegionId;
                /* tslint:disable-next-line: no-bitwise */
                params.mask |= hotelNameHotelBits;

                // make the call to add parameters
                addFeatureFlag(featureFlag, configuration, params, context);
            }
        }
        return params;
    }

    public handlePageLoad(options: any, context: IContext): void {
        // NOTE: The listeners are registered at page load but executed when triggered

        TypeaheadMessage.subscribe(
            ElementFocusedMessage.getTopic(),
            (topic: string, message: ElementFocusedMessage) => {
                // Exposure Logging done only when changeSearch input receives focus
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    // Populate the search prompt under the search input
                    const inputId: string = message.getDomElementId();
                    $("#" + inputId).attr("placeholder", loc.taOneSearchPlaceholderText);
                }
            });

        // This is default behavior for uTA on HSR change search
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(),
            (topic: string, message: InputValueEditedMessage) => {
                // Reset the regionId, hotelId and latLong param
                this.clearRegionIdForChangeSearchSelection();
                this.clearLatLongForChangeSearchSelection();
                this.clearHotelIdForChangeSearchSelection();
                // Remove the searchOverride
                $("input[name='searchPriorityOverride']").val("");
            });

        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, suggestion: SuggestionSelectedMessage) => {

            const hotelId: string = suggestion.getSuggestion().getHotelId().orElse("");
            const regionId: string = suggestion.getSuggestion().getRegionId().orElse("");
            const latLong: string = suggestion.getSuggestion().getLatLong().orElse("");
            const cityName: string = suggestion.getSuggestion().getCity().orElse("");

            if (ExecutionHelper.shouldExecute(context, configuration)) {
                // This fetches the {field: "searchPriorityOverride", value: "213"} for a hotel suggestion
                const params: Optional<IExtraSearchParam[]> =
                    suggestion.getSuggestion().getExtraSearchParams();
                this.regionId = regionId;
                this.latLong = latLong;

                if (!!hotelId) {
                    params.orElse([]).forEach((param: IExtraSearchParam) => {
                        if (param.field === "searchPriorityOverride") {
                            this.searchPriorityOverride = param.value;
                        }
                    });
                    this.selected = hotelId;
                    this.cityName = cityName;
                }
            } else {
                if (hotelId) {
                    this.selected = hotelId;
                } else {
                    this.clearHotelIdForChangeSearchSelection();
                }
            }
        });

        // The following code is to handle regionID, latLong, selected and searchPriorityOverride
        // params at Change Search submit in the URL
        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_GET_QUERY_MESSAGE,
            (uitktopic: string, submitObject: IHsrpSubmitData) => {
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                this.setRegionIdForChangeSearchSelection(submitObject);
                this.setLatLongForChangeSearchSelection(submitObject);

                if (this.selected) {
                    // set selected, regionId, latlong and searchParamOverride
                    this.setSelectedHotelIdForChangeSearchSelection(submitObject);
                } else {
                    // Remove the searchOverride element
                    // to undo the HSR query prexisting previous override
                    $("input[name='searchPriorityOverride']").val("");
                }
            }
        });

        // Update the destination param to the cityName in case of a hotel suggestion selection
        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_BEFORE_UPDATE_HASH_MESSAGE,
            (uitktopic: string, submitObject: IHsrpSubmitData) => {
                if (this.selected) {
                    submitObject.query = IncludeHotelsNearRegion.updateQueryParam(submitObject.query,
                        "destination", this.cityName);
                } else {
                    // Remove the searchPriorityOverride param only if a hotelID search is not submitted
                    if (!$("#selected").val()) {
                        // Remove the searchOverride element
                        // to undo the HSR query presisting previous override
                        $("input[name='searchPriorityOverride']").val("");
                    }
                }
            });
    }

    private setRegionIdForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        if (this.regionId) {
            $("#regionId").val(this.regionId);
            if (submitObject.query && submitObject.query.indexOf("regionId") === -1) {
                submitObject.query += "&regionId=" + this.regionId;
            }
        }
    }

    private clearRegionIdForChangeSearchSelection(): void {
        this.regionId = null;
        $("#regionId").val("");
    }

    private setSelectedHotelIdForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        if (this.selected) {
            $("#selected").val(this.selected);
            if (submitObject.query && submitObject.query.indexOf("selected") === -1) {
                submitObject.query += "&selected=" + this.selected;
            }
            if (submitObject.query && submitObject.query.indexOf("searchPriorityOverride") === -1) {
                submitObject.query += "&searchPriorityOverride=" + this.searchPriorityOverride;
            }
        }
    }

    private clearHotelIdForChangeSearchSelection(): void {
        this.selected = null;
        $("#selected").val("");
        this.searchPriorityOverride = null;
        $("input[name='searchPriorityOverride']").val("");
        this.cityName = null;
    }

    private setLatLongForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        if (this.latLong) {
            $("#latLong").val(this.latLong);
            if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                submitObject.query += "&latLong=" + this.latLong;
            }
        }
    }

    private clearLatLongForChangeSearchSelection(): void {
        this.latLong = null;
        $("#latLong").val("");
    }

}
